import React, { memo, ReactNode, useState, useEffect } from 'react';
import { DropdownToggle, DropdownMenu, UncontrolledDropdown } from 'reactstrap';

export type setOpen = (value: boolean) => void;
export interface GCDropdownProps {
  target: ReactNode;
  children(callback: setOpen): ReactNode;
  container?: string;
  onOpenToggle?(open: boolean): void;
  noDarkText?: boolean;
  tag?: React.ElementType;
  left?: boolean;
  disabled?: boolean;
}

export const GCDropdown = memo((props: GCDropdownProps) => {
  const { onOpenToggle, noDarkText = false, tag = 'a', left = false, disabled = false } = props;
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    onOpenToggle && onOpenToggle(isOpen);
  }, [isOpen, onOpenToggle]);

  return (
    <UncontrolledDropdown
      isOpen={isOpen}
      toggle={(e: any) => {
        if (disabled) return;
        e.stopPropagation();
        setOpen(!isOpen);
      }}
    >
      <DropdownToggle
        tag={tag}
        className={`d-flex ${left ? 'justify-content-start' : 'justify-content-center'}  align-items-center ${noDarkText ? '' : 'text-dark'} `}
      >
        {props.target}
      </DropdownToggle>

      <DropdownMenu positionFixed container={props.container} className="dd-menu_outside">
        {isOpen && props.children(setOpen)}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
});
